// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoControlButton_root__JKF9a","rootMicrophone":"VideoControlButton_rootMicrophone__F6_JJ"};